import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// EN namespaces
import enCommon from './locales/en/common.json'
import enAuth from './locales/en/auth.json'
import enErrors from './locales/en/errors.json'
import enDashboard from './locales/en/dashboard.json'
import enSettings from './locales/en/settings.json'
import enCampaigns from './locales/en/campaigns.json'
import enContacts from './locales/en/contacts.json'
import enOnboarding from './locales/en/onboarding.json'
import enLanding from './locales/en/landing.json'
import enLegal from './locales/en/legal.json'
import enAnalytics from './locales/en/analytics.json'
import enLandingV2 from './locales/en/landingV2.json'

// ES namespaces
import esCommon from './locales/es/common.json'
import esAuth from './locales/es/auth.json'
import esErrors from './locales/es/errors.json'
import esDashboard from './locales/es/dashboard.json'
import esSettings from './locales/es/settings.json'
import esCampaigns from './locales/es/campaigns.json'
import esContacts from './locales/es/contacts.json'
import esOnboarding from './locales/es/onboarding.json'
import esLanding from './locales/es/landing.json'
import esLegal from './locales/es/legal.json'
import esAnalytics from './locales/es/analytics.json'
import esLandingV2 from './locales/es/landingV2.json'

// Simple detection: browser starts with 'es' → Spanish, otherwise English
const browserLang = navigator.language?.startsWith('es') ? 'es' : 'en'

// Check localStorage for explicit user choice (set by LanguageSwitcher only)
// We use a custom key to avoid confusion with i18next's own 'i18nextLng' key
const USER_LANG_KEY = 'tl_preferred_lang'
const savedLang = localStorage.getItem(USER_LANG_KEY)

// Resolve: explicit user choice > browser detection > fallback
function resolveLanguage(): string {
  if (savedLang === 'en' || savedLang === 'es') return savedLang
  return browserLang
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        errors: enErrors,
        dashboard: enDashboard,
        settings: enSettings,
        campaigns: enCampaigns,
        contacts: enContacts,
        onboarding: enOnboarding,
        landing: enLanding,
        legal: enLegal,
        analytics: enAnalytics,
        landingV2: enLandingV2,
      },
      es: {
        common: esCommon,
        auth: esAuth,
        errors: esErrors,
        dashboard: esDashboard,
        settings: esSettings,
        campaigns: esCampaigns,
        contacts: esContacts,
        onboarding: esOnboarding,
        landing: esLanding,
        legal: esLegal,
        analytics: esAnalytics,
        landingV2: esLandingV2,
      },
    },
    lng: resolveLanguage(),
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React already escapes
    },
  })

export { USER_LANG_KEY }

export default i18n
